module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.itemList[0].title))])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('scroller', {
    ref: "scroller"
  }, [_c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "wrap-about indent",
    domProps: {
      "innerHTML": _vm._s(_vm.itemList[0].content)
    }
  }), _vm._v(" "), _vm._l((_vm.itemList), function(item, index) {
    return (index > 0) ? _c('div', {
      staticClass: "wrap-about"
    }, [_c('h3', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.itemList[index].title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.itemList[index].content)
      }
    })]) : _vm._e()
  })], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0431a590!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/about.vue
// module id = 330
// module chunks = 1